import _implicitStylesheets from "./pricing.css";
import _implicitScopedStylesheets from "./pricing.scoped.css?scoped=true";
import _wdsLinkRenderer from "wds/linkRenderer";
import _axBadge from "ax/badge";
import _wdsButton from "wds/button";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div data-testid="details-header" data-scroll-to="pricing-details"${"a0:data-dummy"}${3}><h3 type-style="display-6"${3}>${"t2"}</h3></div>`;
const $fragment2 = parseFragment`<div class="sub-section-header${0}" type-style="display-7" data-testid="details-subsection-header"${2}><b${3}>${"t2"}</b></div>`;
const $fragment3 = parseFragment`<p type-style="body-2" data-testid="details-description"${3}>${"t1"}</p>`;
const $fragment4 = parseFragment`<p type-style="body-2" data-testid="details-limitation-description"${3}>${"t1"}</p>`;
const $fragment5 = parseFragment`<div${3}><p type-style="display-7" data-testid="plan-name"${3}>${"t2"}</p><p type-style="body-2" data-testid="plan-description"${3}>${"t4"}</p></div>`;
const $fragment6 = parseFragment`<p type-style="caption" data-testid="trial-period"${3}>${"t1"}</p>`;
const stc0 = {
  attrs: {
    "grid": "",
    "axis": "column"
  },
  key: 0
};
const stc1 = {
  classMap: {
    "details-description": true
  },
  key: 5
};
const stc2 = {
  "data-testid": "details-custom-description"
};
const stc3 = {
  "plan": true
};
const stc4 = {
  key: 14
};
const stc5 = {
  key: 15
};
const stc6 = {
  "data-testid": "show-more"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element, k: api_key, i: api_iterator, b: api_bind, f: api_flatten} = $api;
  const {_m0} = $ctx;
  return [api_element("div", stc0, api_flatten([api_static_fragment($fragment1, 2, [api_static_part(0, {
    attrs: {
      "data-dummy": $cmp.scrollToParam
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.staticLabels.pricingDetails))]), $cmp.hasSubSectionHeader ? api_static_fragment($fragment2, 4, [api_static_part(2, null, api_dynamic_text($cmp.subSectionHeader))]) : null, api_element("div", stc1, [api_static_fragment($fragment3, 7, [api_static_part(1, null, api_dynamic_text($cmp.pricingDetailsDescription))]), api_static_fragment($fragment4, 9, [api_static_part(1, null, api_dynamic_text($cmp.pricingRequirementsAndLimitation))]), api_custom_element("wds-link-renderer", _wdsLinkRenderer, {
    attrs: stc2,
    props: {
      "plainText": $cmp.pricingCustomDetailsDescription
    },
    key: 10
  })]), api_iterator($cmp.plans, function (plan) {
    return plan.isVisible ? api_element("div", {
      classMap: stc3,
      key: api_key(11, plan.index)
    }, [api_static_fragment($fragment5, 13, [api_static_part(2, null, api_dynamic_text(plan.name)), api_static_part(4, null, api_dynamic_text(plan.details))]), api_element("div", stc4, [api_element("div", stc5, [plan.hasTrialAvailable ? api_static_fragment($fragment6, 17, [api_static_part(1, null, api_dynamic_text(plan.trialPeriodDaysText))]) : null]), plan.isStartingPrice ? api_custom_element("ax-badge", _axBadge, {
      props: {
        "text": $cmp.staticLabels.lowestStartingPrice,
        "theme": "green"
      },
      key: 18
    }) : null])]) : null;
  }), $cmp.isShowMoreVisible ? api_custom_element("wds-button", _wdsButton, {
    attrs: stc6,
    props: {
      "variant": "tertiary",
      "icon": $cmp.showMoreOrLessSymbol,
      "size": "xsmall",
      "label": $cmp.showMoreOrLessText
    },
    key: 19,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleShowMore))
    }
  }) : null]))];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2d4m1kpfbp7";
tmpl.legacyStylesheetToken = "undefined-_pricing";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
